<!-- Skip link (#1288): keyboard users land on the header nav first; this lets
     them jump past it straight to the booking funnel. Off-screen until focused. -->
<a class="skip-link" href="#main-content">Skip to main content</a>
<bodyanalytics-header></bodyanalytics-header>
<main id="main-content" tabindex="-1">
  <section class="">
    @if (auth.isLoading$ | async) {
      <div class="container">
        <bodyanalytics-loading-spinner [fullscreen]="true" />
      </div>
    } @else {
      <!-- g-0: the single full-bleed column needs no gutters; g-4/g-lg-5 added
           negative row margins (up to -24px) with no container to absorb them,
           causing horizontal overflow on every page. -->
      <div class="row g-0">
        <div class="col-12">
          <router-outlet></router-outlet>
        </div>
      </div>
    }
  </section>
</main>
<bodyanalytics-footer></bodyanalytics-footer>
<!-- App-wide toast notifications — rendered once, all calendar routes (#1547 fix) -->
<bodyanalytics-toast-container />
